import styled from "styled-components";

export const ReportDiv = styled.div`
  margin: 2rem;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */
  gap: 2rem;

  .title {
    h1 {
      display: flex;
      align-items: center;
      gap: 1rem;

      span {
        border-radius: 5px;
        font-size: 1.1rem;
        color: #fff;
        font-weight: 400;
        background: #660099;
        padding: 0.3rem 0.6rem 0.5rem;
      }
    }
  }

  .btn-report {
    width: max-content;
  }

  .filters {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    /* justify-content: center; */
    /* align-items: center; */
  }

  .filters .type,
  .filters .select-react {
    width: 250px;
    height: max-content;
  }

  .date {
    position: relative;
  }

  .switch {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .date-inp {
    width: 250px;
    height: 38px;
    position: relative;

    display: flex;
    align-items: center;

    color: hsl(0, 0%, 50%);
    font-size: 15px;

    .icon {
      position: absolute;
      height: 1.8rem;
      width: 1.8rem;
      padding: 4px;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);

      color: #555;
    }

    input {
      border: none;
      padding: 0 10px;

      background-color: transparent;
      border-color: rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;
    }
  }

  .date-picker {
    border: #555 solid 1px;
    position: absolute;
    z-index: 100;
    right: -320px;
    top: 48px;
  }
`;

export const ModalAlertDiv = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;

  gap: 1rem;
`;
